import { useTranslation } from "react-i18next";
import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useNaviProduct } from "../hooks/useNaviProduct";
interface MenuProductProps {
  redirectUrl: string;
  categories?: LocationDTO[];
}
const MenuProduct: React.FC<MenuProductProps> = ({
  redirectUrl,
  categories,
}) => {
  const { naviProduct } = useNaviProduct();
  const { t } = useTranslation();
  const [mainCategory, setMainCategory] = useState<LocationDTO | undefined>();
  const [cityCategory, setCityCategory] = useState<LocationDTO | undefined>();
  const [subCategory, setSubCategory] = useState<LocationDTO | undefined>();
  const [isSubmit, setIsSubmit] = useState(false);

  const menuRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (menuRef.current) {
      //  Utils.adjustPosition(menuRef.current);
    }
  }, []);
  useEffect(() => {
    if (isSubmit) {
      handleClick();
      resetSelections();

      setIsSubmit(false);
    }
  }, [isSubmit]);

  const navigate = useNavigate();
  useEffect(() => {
    if (cityCategory) {
      setMainCategory(undefined);
      setSubCategory(undefined);
    }
  }, [cityCategory]);

  const chunkArray = (arr: LocationDTO[], chunkSize: number) => {
    return arr.reduce<LocationDTO[][]>((result, item, index) => {
      const chunkIndex = Math.floor(index / chunkSize);
      if (!result[chunkIndex]) {
        result[chunkIndex] = [];
      }
      result[chunkIndex].push(item);
      return result;
    }, []);
  };
  const handleClick = () => {
    const queryParams = [
      cityCategory && `city=${cityCategory.id}`,
      mainCategory && `category=${mainCategory.id}`,
      subCategory && `subCategory=${subCategory.id}`,
    ]
      .filter(Boolean)
      .join("&");

    const redirectPath = queryParams ? `${redirectUrl}?${queryParams}` : "/";
    navigate(redirectPath);
  };

  const renderCategories = (
    vari: "MAIN" | "SUB" | "CITY",
    title: string,
    categories?: LocationDTO[],
    onClick?: (item: LocationDTO) => void,
    selectedCategory?: LocationDTO,
  ) => {
    if (!categories || categories.length === 0) return null;
    const categoryChunks = chunkArray(categories, 4);

    return (
      <div className="w-full">
        <h3 className="mb-5 text-[1.125rem] font-semibold leading-[1.5325rem] text-[#232323]">
          {title}
        </h3>
        <ul className="flex flex-wrap gap-8">
          {categoryChunks.map((chunk, chunkIndex) => (
            <div className="ml-[-2rem]" key={chunkIndex}>
              {chunk.map((item, index) => (
                <li
                  key={index}
                  onClick={() => {
                    if (onClick?.(item)) {
                      return;
                    }
                    if (!item.subCategories?.length) {
                      setIsSubmit(true);
                    }
                  }}
                  className={`${
                    selectedCategory?.id === item.id
                      ? "text-[#007AFF]"
                      : "text-[#5E6D77]"
                  } min-w-[10.75rem] cursor-pointer py-2 pl-8 text-[0.875rem] font-normal leading-[1.1919rem] hover:bg-gray-100`}
                >
                  {t(item.name)}
                </li>
              ))}
            </div>
          ))}
        </ul>
      </div>
    );
  };

  const resetSelections = () => {
    setCityCategory(undefined);
    setMainCategory(undefined);
    setSubCategory(undefined);
  };

  return (
    <aside
      ref={menuRef}
      className="absolute bottom-[18.75rem] left-0 w-[53rem] space-y-8 rounded-b-[0.9375rem] bg-white p-8 opacity-0 shadow-lg transition-opacity duration-300 group-hover:bottom-auto group-hover:top-[101%] group-hover:opacity-100"
    >
      {renderCategories(
        "CITY",
        t("Location"),
        categories,
        (item) => {
          // setCityCategory(item);
          naviProduct({
            slug: item.productSlug,
            productType: "PASS",
          });
          return true;
        },
        cityCategory,
      )}
      {renderCategories(
        "MAIN",
        t("Main Categories"),
        cityCategory?.subCategories,
        (item) => {
          setMainCategory(item);
        },
        mainCategory,
      )}
      {renderCategories(
        "SUB",
        t("Sub Categories"),
        mainCategory?.subCategories,
        (item) => {
          setSubCategory(item);
        },
        subCategory,
      )}
    </aside>
  );
};

export default MenuProduct;
